/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneSearch from 'base/components/standalone/Search';

export const DynamicStandaloneSearch = StandaloneSearch;
export type DynamicStandaloneSearchProps = PropsFromComponent<typeof StandaloneSearch>;

export const DynamicStandaloneSearchWith = (extras: DynamicStandaloneExtras): typeof StandaloneSearch => {
    return function DynamicStandaloneSearch(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'Search');
        return <StandaloneSearch {...mergeProps({ options: { theme } }, props)} />;
    }
}